import {
  CHART_COLOR_PALETTE_ONE,
  CHART_COLOR_PALETTE_TWO,
} from 'v2/core/constants/colorPalettes';

export interface FeatureFlagType {
  name: string;
  fallback: boolean;
}

/* Check README to view the
usage guide of feature flag variables */
export interface FeatureFlagVariable<T> {
  name: string;
  variableName: string;
  fallback: T;
}

export interface ColorPalette {
  primary: string[];
  secondary: string[];
}

export const ColorPaletteFeatureFlag: FeatureFlagVariable<ColorPalette> = {
  name: 'collor_palette',
  variableName: 'palette_config',
  fallback: {
    primary: CHART_COLOR_PALETTE_ONE,
    secondary: CHART_COLOR_PALETTE_TWO,
  },
};

export const changeAnalysisOwnerFFlag: FeatureFlagType = {
  name: 'change_analysis_owner',
  fallback: false,
};
